import { extendTheme, type ThemeConfig } from '@chakra-ui/react';
import fonts from './assets/fonts';
import * as components from './components';
import palette from './assets/palette';

const breakpoints = {
    base: '0',
    xxs: '320px',
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1440px',
    xxxl: '1600px',
};

const config: ThemeConfig = {
    initialColorMode: 'light',
    useSystemColorMode: false,
};

const customTheme = extendTheme({
    config,
    breakpoints,
    color: { ...palette },
    components: {
        ...components,
    },
    ...fonts,
});
export default customTheme;
